import { TopProgressController } from './TopProgressController';

let topProgressController: TopProgressController | null = null;

const getTopProgressController = (): TopProgressController => {
  if (!topProgressController) {
    topProgressController = new TopProgressController();
  }

  return topProgressController;
};

export const startTopProgress = (): void => {
  getTopProgressController().start();
};

export const setTopProgress = (value: number): void => {
  getTopProgressController().setProgress(value);
};

export const doneTopProgress = (): void => {
  getTopProgressController().done();
};

export const failTopProgress = (): void => {
  getTopProgressController().fail();
};

export const resetTopProgress = (): void => {
  getTopProgressController().reset();
};

export const withTopProgressColor = (color?: string): (() => void) => {
  const cssVar = '--ips-frontfw-top-progress-color';
  const root = document.documentElement;
  const previousInline = root.style.getPropertyValue(cssVar);
  const hasPreviousInline = previousInline.trim().length > 0;

  if (color && color.trim().length > 0) {
    root.style.setProperty(cssVar, color.trim());
  }

  return () => {
    if (hasPreviousInline) {
      root.style.setProperty(cssVar, previousInline);
      return;
    }

    root.style.removeProperty(cssVar);
  };
};

export { TopProgressController };
